import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// The roles each gated page allows, matching the nav: Customers is hidden
// from drivers only; History, Expenses and Reports show to owners and admins.
export const CUSTOMERS_ROLES = ['owner', 'admin', 'crew_lead'];
export const ADMIN_ROLES = ['owner', 'admin'];

// A signed-in page. Signed out goes to /login. With roles, a user whose role
// is not listed goes to /dashboard, so typing the URL reaches no more than the
// nav offers.
const ProtectedRoute = ({ children, roles }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (roles && !roles.includes(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;
